const Button = ({label, action, isDanger}) => {
  return (
    <button className={`py-1.5 px-5 lg:px-11 border-[0.5px]  border-solid hover:text-white whitespace-nowrap uppercase ${isDanger?'border-red hover:bg-red':'border-primary hover:bg-primary'}`} onClick={action}>
      {label}
    </button>
  )
}
export default Button;